<template>
    <div class="pl-5 pt-2">
        <div class="iform-row mt-5">
            <div class="row">
                <div class="col-12">
                    <div class="form-group d-inline-flex w-100">
                        <label class="input-label mr-3 w-25">Announcement Date <span class="asterisk">*</span></label>
                        <date-picker
                            id="release_date"
                            placeholder="Announcement Date"
                            class="w-25"
                            name="release_date"
                            :is-required="true"
                            :config="datepickerConfig()"
                            :error="errorsList['release_date'] ? errorsList['release_date'][0] : ''"
                            v-model="notificationData.releaseDate"
                        ></date-picker>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group d-inline-flex w-100">
                        <label class="input-label mr-3 w-25">Type <span class="asterisk">*</span></label>
                        <div class="w-25 form-input">

                        <app-select
                                placeholder="Type"
                                name="type"
                                id="type"
                                :is-required="true"
                                :is-multiple="false"
                                :use-search="false"
                                :options="typeOptions"
                                :value="getAttributeByName('type')"
                                :error="errorsList['type'] ? errorsList['type'][0] : ''">
                        </app-select>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group d-inline-flex w-100">
                        <label class="input-label mr-3 w-25">Title <span class="asterisk">*</span></label>
                        <app-input
                            id="title"
                            name="title"
                            placeholder="title"
                            class="w-50"
                            :is-required="true"
                            :value="getAttributeByName('title')"
                            :error="errorsList['title'] ? errorsList['title'][0] : ''"
                        ></app-input>
                        <input type="hidden" name="is_active" value="0">
                        <app-checkbox
                            id="is_active"
                            name="is_active"
                            label="Active"
                            class="w-25 pl-4"
                            v-model="notificationData['is_active']"
                        />

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group d-inline-flex w-100">
                        <label class="input-label mr-3 w-25">Message <span class="asterisk">*</span></label>
                        <div class="w-50 form-input">

                        <text-editor
                            id="data"
                            name="data"
                            placeholder="Release Data"
                            rows="5"
                            class="w-100"
                            :with-image="false"
                            :with-para="false"
                            :is-required="true"
                            :error="errorsList['data'] ? errorsList['data'][0] : ''"
                            :value="getAttributeByName('data')"
                        ></text-editor>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        validationErrors: {
            type: String,
            default: ''
        },
        oldValues: {
            type: String,
            default: ''
        },
        notification: {
            type: String,
            default: ''
        },
        options: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            notificationData: [],
            oldInputValuesList: {},
            releaseDate: new Date(),
            typeOptions : JSON.parse(this.options)
        };
    },

    created() {
        this.setOldInputValuesList();
        this.setExistingNotificationInfo();
    },

    methods: {
        setOldInputValuesList() {
            let notificationOldValues = JSON.parse(this.oldValues);
            if (notificationOldValues) {
                return this.oldInputValuesList = notificationOldValues;
            }
        },

        setExistingNotificationInfo() {
            let existingNotification = JSON.parse(this.notification);
            if (existingNotification.started_at) {
                existingNotification.releaseDate = [existingNotification.started_at, existingNotification.expired_at]
            }
            else {
                if (this.getAttributeByName('release_date')) {
                    const releaseDate = this.getAttributeByName('release_date').split(" to ");
                    existingNotification.releaseDate = [releaseDate[0], releaseDate[1]];
                }
                if (this.getAttributeByName('is_active')) {
                    existingNotification['is_active'] = this.getAttributeByName('is_active') === "1";
                }
            }

            if (existingNotification) {
                return this.notificationData = existingNotification;
            }
        },

        getAttributeByName(attribute) {
            if(Object.keys(this.oldInputValuesList).length > 0){
                return this.oldInputValuesList[attribute];
            } else if(this.notificationData[attribute]) {
                return this.notificationData[attribute];
            } else {
                return '';
            }
        },

        datepickerConfig() {
            return {
                mode: 'range',
                enableTime: false,
                altFormat: 'm/j/Y',
                dateFormat: 'Y-m-d',
            };
        },
    },

    computed: {
        errorsList() {
            if (this.validationErrors.length > 0) {
                return JSON.parse(this.validationErrors);
            }
            return new Object();
        },

    },
};
</script>

<style scoped lang="scss">
.input-label {
    width: 30%;
}

</style>
